<template>
 <div class="fc-page mg-page rp-page rp-flow_dashboard">
  <nav aria-label="面包屑"><v-breadcrumbs :items="breadcrumbs" divider="/" class="mg-breadcrumb" /></nav>
  <header class="fc-heading"><div><h1>收支报表</h1><p>查看月度支出、其他收入与费用构成</p></div><span class="rp-heading-symbol" aria-hidden="true"><v-icon size="25" color="#d9363e">mdi-chart-box-outline</v-icon></span></header>
  <section class="fc-filters rp-year-filters" aria-label="统计年份筛选"><div class="fc-filter-heading"><h3>统计范围</h3><span>选择年份后查询</span></div><form class="rp-year-form" @submit.prevent="refresh"><div class="fc-filter-cell"><v-select :items="yearItems" v-model="query.year" item-text="name" item-value="value" label="年份" dense outlined hide-details color="#d9363e" /></div><v-btn type="submit" depressed color="#d9363e" dark><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></form></section>
  <div class="rp-chart-grid">
   <article class="rp-chart"><div class="rp-chart-heading"><div><h3>月度支出金额</h3><p>按月查看校区支出情况</p></div></div><div class="rp-chart-body"><ve-histogram v-if="monthPayOutData.rows.length" :data="monthPayOutData" :colors="['#d9363e','#6087b1','#6ca68e','#d6ab68','#9b87af']" :judge-width="true" height="360px" :extend="Object.assign({}, chartExtend, {title:{show:false},textStyle:{fontFamily:'Microsoft YaHei',color:'#718096'},'legend.textStyle':{color:'#718096'}})" /><div v-else class="rp-chart-empty" role="status"><v-icon size="32">mdi-chart-box-outline</v-icon><h4>暂无统计数据</h4><p>当前查询范围内暂无可展示的记录</p></div></div><div v-if="summaryText" class="rp-chart-summary">{{summaryText}}</div></article>
   <article class="rp-chart"><div class="rp-chart-heading"><div><h3>全年总支出占比</h3><p>按支出类型查看费用构成</p></div></div><div class="rp-chart-body"><ve-pie v-if="totalPayRateData.rows.length" :data="totalPayRateData" :colors="['#d9363e','#6087b1','#6ca68e','#d6ab68','#9b87af']" :judge-width="true" height="360px" :extend="Object.assign({}, {}, {title:{show:false},textStyle:{fontFamily:'Microsoft YaHei',color:'#718096'},'legend.textStyle':{color:'#718096'}})" /><div v-else class="rp-chart-empty" role="status"><v-icon size="32">mdi-chart-box-outline</v-icon><h4>暂无统计数据</h4><p>当前查询范围内暂无可展示的记录</p></div></div></article>
   <article class="rp-chart"><div class="rp-chart-heading"><div><h3>月度其他收入金额</h3><p>按月查看其他收入情况</p></div></div><div class="rp-chart-body"><ve-histogram v-if="monthIncomesData.rows.length" :data="monthIncomesData" :colors="['#d9363e','#6087b1','#6ca68e','#d6ab68','#9b87af']" :judge-width="true" height="360px" :extend="Object.assign({}, incomeExtend, {title:{show:false},textStyle:{fontFamily:'Microsoft YaHei',color:'#718096'},'legend.textStyle':{color:'#718096'}})" /><div v-else class="rp-chart-empty" role="status"><v-icon size="32">mdi-chart-box-outline</v-icon><h4>暂无统计数据</h4><p>当前查询范围内暂无可展示的记录</p></div></div><div v-if="monthIncomesData.summaryText" class="rp-chart-summary">{{monthIncomesData.summaryText}}</div></article>
   <article class="rp-chart"><div class="rp-chart-heading"><div><h3>全年其他收入占比</h3><p>按收入类型查看其他收入构成</p></div></div><div class="rp-chart-body"><ve-pie v-if="totalIncomeRateData.rows.length" :data="totalIncomeRateData" :colors="['#d9363e','#6087b1','#6ca68e','#d6ab68','#9b87af']" :judge-width="true" height="360px" :extend="Object.assign({}, {}, {title:{show:false},textStyle:{fontFamily:'Microsoft YaHei',color:'#718096'},'legend.textStyle':{color:'#718096'}})" /><div v-else class="rp-chart-empty" role="status"><v-icon size="32">mdi-chart-box-outline</v-icon><h4>暂无统计数据</h4><p>当前查询范围内暂无可展示的记录</p></div></div></article>
  </div>
 </div>
</template>

<script>
	import utils from "../../../config/utils"
	export default {
		name: "flow-dashboard",
		data() {
			this.chartExtend = {
			 //  title: {
				// text: '缴费&消课收入报表'
			 //  },
			  series: {
				barWidth: 40,
				label:{show:true,position:'top'}
			  }
			},
			this.incomeExtend={
				series: {
					barWidth: 40,
					label:{show:true,position:'top'}
				}
			}
			return {
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '数据报表',
						disabled: true
					},
					{
						text: '支出报表',
						disabled: true
					},
				],
				shopId:"",
				yearItems:[],
				summaryText:"",
				query: {
					year:""+new Date().getFullYear()
				},
				monthPayOutData: {
					columns: ['月份', '支出金额'],
					rows: [], 
				},
				totalPayRateData: {
					columns: ['支出类型', '金额'],
					rows: [], 
				},
				monthIncomesData: {
					columns: ['月份', '收入金额'],
					rows: [], 
					summaryText:"",
				},
				totalIncomeRateData: {
					columns: ['收入类型', '金额'],
					rows: [], 
				},
			}
		},
		mounted() {

		},
		created() {
			this.shopId = utils.getCurrentShopId();
			this.generateYearItems();
			// 默认本年度
			const now = new Date();
			const nowYear = now.getFullYear();
			this.query.year = nowYear.toString();
			
			
			this.getChartData();
			this.getTotalPayRateList();
			this.getMonthIncomesData();
			this.getTotalIncomeRateList();

		},
		methods: {
			generateYearItems(){
				let fromYear = 2018;
				const now = new Date();
				const nowYear = now.getFullYear();
				
				for (let i = fromYear; i <= nowYear; i++) {
					this.yearItems.push({value:i.toString(),name:i.toString()+"年"})
				}
			},
			refresh(){
				this.getChartData();
				this.getTotalPayRateList();
				this.getMonthIncomesData();
				this.getTotalIncomeRateList();
			},
			getChartData() {
				const that = this;

				let url = `/report/payout/dashboard/${this.query.year}?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				
				this.axios.get(url).catch(()=>{
					return;
				}).then(response => {
					
					if (response.data["code"] === 200) {
						
						console.log(response.data["data"]["dataList"]);
						
						const dataList = response.data["data"]["dataList"] || [];
						
						let payOutList = [];
					
						if (dataList.length > 0){
							dataList.forEach((item,index)=>{
								let monthPay = {"月份":item.month,"支出金额":item.payAmount}
								payOutList.push(monthPay);
							})
						}
						// 月支出金额
						that.monthPayOutData.rows = payOutList;
					

						that.summaryText  =  response.data["data"]["summaryText"];
						return
					}else{
						that.$noty.error("获取失败：" + response.data["message"]);
					}
				
					
				})
			},
			getMonthIncomesData() {
				
				// 获取月度其他收入数据
				const that = this;
			
				let url = `/report/month/other/income/${this.query.year}?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				
				this.axios.get(url).catch(()=>{
					return;
				}).then(response => {
					
					if (response.data["code"] === 200) {
						console.log("获取其他收入");
						console.log(response.data["data"]["dataList"]);
						console.log("获取其他收入");
						const dataList = response.data["data"]["dataList"] || [];
						
						let incomesList = [];
					
						if (dataList.length > 0){
							dataList.forEach((item,index)=>{
								let monthPay = {"月份":item.month,"收入金额":item.amount}
								//let monthPay = {"月份":item.month,"活动收费":item.IN_ACTIVITY,"订单收入":item.IN_ORDER_INCOME,"广告收入":item.IN_AD,"其他收入":item.IN_OTHER}
								incomesList.push(monthPay);
							})
						}
						// 月收入金额
						that.monthIncomesData.rows = incomesList;
					
						that.monthIncomesData.summaryText  =  response.data["data"]["summaryText"];
						return
					}else{
						that.$noty.error("获取失败：" + response.data["message"]);
					}
				
					
				})
			},
			getTotalPayRateList(){
				// 获取总支出占比
				const that = this;
				let url = `/report/payout/rate/${this.query.year}?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				
				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						const dataList = response.data["data"]["dataList"] || [];
					
						console.log(dataList);
						
						that.totalPayRateData.rows = dataList;
						
						return
					}
				})
			},
			getTotalIncomeRateList(){
				// 获取总收入占比
				const that = this;
				let url = `/report/other/income/rate/${this.query.year}?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				
				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						const dataList = response.data["data"]["dataList"] || [];
					
						console.log('income',dataList);
						
						that.totalIncomeRateData.rows = dataList;
						
						return
					}
				})
			},
			
		}
	}
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/reports-management.scss";
</style>
